
<template>
  <div class="animated fadeIn py3">
    <template>
      <template>
      <div class="clearfix col-11" >
            <div class="col-12 px0 mx3">
                    <div class="col-12 px0">
                      <div class="flex justify-start mt3">
                        <p class="h4 semi-bold line-height-2 my2 darkblue">
                          Alle anbefalinger
                        </p>
                      </div>  
                      <p class="h5 regular darkblue line-height-golden my3">
                        Når du har skrevet en anbefaling, kan du se den her.
                      </p>
                        <div class="col-12 flex px0 mb2">
                          <div class="col-9 flex justify-start items-center py1 border muted-border mediumgrey shadow">
                            <div class="flex-none px2">
                              <svg class="relative" style="top:3px;" width="18" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path class="st0" d="M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"/></svg>
                            </div>
                            <input class="searchBox gibson h4 darkblue regular mb0 p2 col-10 pl0" type="search" name="search" v-model="search" placeholder="Søg efter" style="background:transparent;border:0px!important;">
                            <!-- <input type="submit" value="Search" class="searchButton"> -->
                          </div>
                          <div class="col-3 px0">
                            <button v-b-toggle.m2m class=" col-12 p2 px2 py1 gibson border muted-border dark-button shadow not-rounded flex justify-center items-center" style="height:76px;">
                              <span class="h5 mb0 mr2">Filter</span>
                              <span class="when-closed">
                                <span class="relative" style="top:3px;">
                                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                                </span>
                              </span>
                              <span class="flex-none when-opened">
                                <span class="relative" style="top:3px;">
                                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>
                    </div>
            </div>
            <div class="py1"></div>
            <div class="ml2 flex flex-column col-12 justify-start">
              <!-- eslint-disable -->
              <div class=" p2 highlights border shakespeare-border--light mb2 col-12" v-for="(item,index) in filteredItem" :key="index" v-if="item.UF_STATUS !== 'DELETED'" >
              <div class="flex">
                <!-- Image -->
                <div  class="col-2 flex p0 pr2 justify-center">
                  <img id="imagedivreviewanbefaling" class="cover" :src="item.PHOTO" width="90%" alt="" v-if="item.PHOTO !== null && item.PHOTO !== ''">
                  <img id="imagedivreviewanbefaling" class="cover" src="https://www.haandvaerker.dk/uploads/00.webp" width="90%" alt="" v-else>
                </div>
                <!-- Details -->
                <div class="col-7 p0 pr2">
                  <div class="flex items-center mb1">
                    <div class="pr2 flex items-center">
                      <image-rating :rating="parseInt(item.UF_RATING_OVERALL)" src='/static/svg/single-house.svg' :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
                    </div>
                    <p class="cyprus semi-bold m0" v-if="item.HomeownerName">{{item.HomeownerName.name}}</p>
                  </div>
                  <div class="mb1 semi-bold">
                    <div class="cyprus flex">
                      <div class="headline easternblue mr1">{{item.UF_HEADLINE}}</div>
                      <div class="mr1">|</div> 
                      <div class="small">{{moment(new Date(item.UF_REVIEW_DATE)).format('D MMMM YYYY')}}</div>
                    </div>
                  </div>
                  <div class="flex">
                    <p class="font14 mediumgrey mb0">{{item.UF_COMMENT}}</p>
                    <a type="button" @click="openreply(item)" v-if="item.UF_ANSWER !== ''" class=" no-underlined pointer font14" >... view reply</a>
                  </div>
                </div>
                <!-- Action buttons -->
                <div class="col-2 flex ml-auto items-center p0">
                  <div class="col-12 p0">
                    <button @click="showformreditreview(item)" class="flex col-12 justify-center items-center py1 outlined-primary-button button-padding  semi-bold font14 mb1">
                      <i class="el-icon-edit mr1"></i>Redigere
                    </button>
                    <button @click="deleteanbefal(item)" class="flex col-12 justify-center items-center py1 outlined-delete-button border red-border button-padding mb1 semi-bold font14">
                      <i class="el-icon-delete mr1"></i>Slet
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- eslint-enable -->
            </div>
      </div>
      <b-modal centered hide-footer id="editReviewForm" ref="editReviewForm"  no-close-on-esc no-close-on-backdrop>
      <div>
          <div class=" col-12 flex justify-between items-center pt1 my2 px2 mx-auto">
            <p class="h4 cyprus line-height-1 semi-bold m0 p0 modal-title">Redigere Anbefal</p>
            <button class="right h4 p0 primary-white-button close pointer" @click="closeformreditreview()">
              <i class="el-icon-circle-close"></i>
            </button>
        </div>
        <div class="clearfix">
          <div>
              <el-form id="cvrfrom" :model="anbefalform" class="md-col-11 lg-col-11 sm-col-12 mx-auto" :rules="anbefalformrules" ref="mainanbefalform" label-position="top">
              <div class="flex flex-row mobile-flex-column">
                <div class="m0 p0 lg-col-12 md-col-12 sm-col-12">
                <el-form-item label="Headline" id="Firmanavn" prop="headline" class="border-none">
                    <el-input v-model="anbefalform.headline"  class="border wizard-border white-background" placeholder="Navn Firma"></el-input>
                </el-form-item>
                </div>
              </div>
              <div class="flex flex-row mobile-flex-column">
                <div class="m0 p0 mp0 lg-col-12 md-col-12 sm-col-12">
                  <el-form-item label="Comment" prop="comment" class="border-none p0 ">
                      <el-input v-model="anbefalform.comment" class="border wizard-border white-background" placeholder="Hans Hansen"></el-input>
                  </el-form-item>
                  </div>
              </div>
              <div class="flex flex-row mobile-flex-column mt2">
                <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 sm-col-12">
                  <label>Kommunikation</label>
                  <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Kommunikation"></image-rating>
                  </div>
                  <div class="m0 p0 lg-col-6 md-col-6 sm-col-12">
                  <label>Overholdte Tidplanerne</label>
                  <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Overholdte"></image-rating>
                </div>
              </div>
              <div class="flex flex-row mobile-flex-column mt2">
                <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 sm-col-12">
                  <label>Realistike forventninger</label>
                  <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Realistike"></image-rating>
                  </div>
                  <div class="m0 p0 lg-col-6 md-col-6 sm-col-12">
                  <label>Samarbejdsvillighed</label>
                  <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Samarbejdsvillighed"></image-rating>
                </div>
              </div>
              <div class="flex flex-row mobile-flex-column mt2">
                <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 sm-col-12">
                  <label>Økomonisk sikkerhed</label>
                  <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.sikkerhed"></image-rating>
                  </div>
                  <div class="m0 p0 lg-col-6 md-col-6 sm-col-12">
                  <label>Adgang til arbejdet</label>
                  <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Adgang"></image-rating>
                </div>
              </div>
              <div class="flex mobile-flex-column my3 ">
                <!-- <button type="button" @click="backstep()" class="mt2 not-rounded md-col-4 lg-col-4 sm-col-12 outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1"> <i class="el-icon-back pr1"></i>Tilbage
                </button> -->
                <button type="button" @click="updatereview()" class="mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover ml-auto p2 px2 line-height0 mb1">Gemme <i class="pl1 el-icon-right"></i>
                </button>
              </div>
              
          </el-form>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal centered hide-footer id="replyanswer" ref="replyanswer">
      <div>
        <div class="col-11 flex justify-end pt1 p0 mx-auto  my2">
          <button class="right h4 p0 primary-white-button pointer close" @click="closeanswer()">
            <i class="el-icon-circle-close"></i>
          </button>
        </div>
      </div>
      <div class="clearfix">
        <div class="md-col-11 lg-col-11 sm-col-12 mx-auto">
            <div class="flex flex-row mobile-flex-column">
              <div class="m0 p0 lg-col-12 md-col-12 sm-col-12 mt2 border border-left-0 border-right-0 border-top-0 my1">
                <div class="col-12 fle flex-column p0">
                  <div class="medium flex p0 m0 flex items-end">
                    <image-rating :rating="parseInt(answerselected.UF_RATING_TIME)" src='/static/svg/single-house.svg' :max-rating="5" :increment="0.5" :item-size="20" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
                    <span class="mediumgrey px1"> | </span>
                    {{moment(new Date(answerselected.UF_REVIEW_DATE)).format('D MMMM YYYY')}}
                    <p class="flex items-center justify-start m0" v-if="answerselected.UF_STATUS === 'APPROVED'">
                      <span class="pl1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#19A3C0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                      </span>
                      <span class="easternblue" style="font-size:10px">Verificeret</span>
                    </p>
                  </div>
                  <div class="headline h6 easternblue mx-auto m0">{{answerselected.UF_HEADLINE}}</div>
                  <p class="font14 darkblue mb0">"{{answerselected.UF_COMMENT}}"</p>
                </div>
              </div>
            </div>
            <div class="flex flex-row mobile-flex-column mediumgrey-background mb2" v-if="answerselected.UF_ANSWER">
              <div class="flex flex-column items-center justify-center pl2 p2" style="width:150px;">
                <span>
                  <img :src="answerselected.HomeownerName.AVATAR ? answerselected.HomeownerName.AVATAR : 'https://www.haandvaerker.dk/content/3.0/img/supplier/rating/customer.png'" width="50" height="50" class="rounded-circle border">
                </span>
                <p class="font12  darkblue mb0" >{{answerselected.HomeownerName.name}}</p>
              </div>
              <div class="m0 mp0 lg-col-12 md-col-12 sm-col-12 py2 px1 ">
                <p class="font12 semi-bold darkblue mb0" >{{moment(new Date(answerselected.UF_ANSWER_TIMESTAMP)).format('D MMMM YYYY')}}</p>
                <p class="h6 semi-bold darkblue mb0" >"{{answerselected.UF_ANSWER}}"</p>
              </div>
            </div>
        </div>
      </div>
    </b-modal>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
    </template>
    <div class="py4"></div>
    </template>
  </div>
</template>
<script>
import StarRating from 'vue-star-rating'
import {ImageRating} from 'vue-rate-it'
import Simplert from 'vue2-simplert'
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'anbefalinger',
  components: {
    StarRating,
    ImageRating,
    Simplert,
    ErrorHandler
  },
  data () {
    return {
      haaId: '',
      salesPerson: '',
      search: '',
      resultreviews: [],
      selectedReview: [],
      filteredItem: [],
      anbefalform: {
        reviewId: '',
        customerId: '',
        headline: '',
        comment: '',
        Kommunikation: 0,
        Overholdte: 0,
        Realistike: 0,
        Samarbejdsvillighed: 0,
        sikkerhed: 0,
        Adgang: 0
      },
      anbefalformrules: {
        headline: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste en gyldig title',
          trigger: 'blur'
        }],
        comment: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit comment',
          trigger: 'blur'
        }]
      },
      answerselected: []
    }
  },
  created () {
    this.Reload()
    this.salesPerson = localStorage.getItem('id_token_portalbitrix')
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      this.$http.get(this.$bitrixapi + 'partner/GetPartnersReviewsDoneOnClient', {headers}, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.resultreviews = res.data
              this.filteredItem = this.resultreviews
            }
          },
          response => {
            console.log('error in loading all Review')
          }
        )
    },
    showanswer (item) {
      this.$refs['replyanswer'].show()
      this.answerselected = item
    },
    closeanswer () {
      this.$refs['replyanswer'].hide()
    },
    openreply (item) {
      this.showanswer(item)
    },
    showformreditreview (item) {
      this.$refs['editReviewForm'].show()
      this.reviewSelect(item)
    },
    reviewSelect (item) {
      this.selectedReview = item
      this.anbefalform.reviewId = item.ID
      this.anbefalform.customerId = item.UF_CUSTOMER_ID
      this.anbefalform.headline = item.UF_HEADLINE
      this.anbefalform.comment = item.UF_COMMENT
      this.anbefalform.Kommunikation = item.UF_RATING_COMMUNICATION
      this.anbefalform.Overholdte = item.UF_RATING_TIME
      this.anbefalform.Realistike = item.UF_RATING_REALISTIC_EXPECTATIONS
      this.anbefalform.Samarbejdsvillighed = item.RECOMMEND_COMPANY_RATING
      this.anbefalform.sikkerhed = item.UF_RATING_FINANCIAL_SECURITY
      this.anbefalform.Adgang = item.UF_RATING_ACCESS
    },
    updatereview () {
      var error = 0
      this.$refs['mainanbefalform'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) { return }
      this.$confirm('Opdater din anmeldelse?', {
        confirmButtonText: 'Indsend',
        cancelButtonText: 'Annuller',
        type: 'warning'
      }).then(() => {
        this.haaid = localStorage.getItem('haaid')
        this.salesPerson = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        var data = {
          ID: this.anbefalform.reviewId,
          UF_HEADLINE: this.anbefalform.headline,
          UF_COMMENT: this.anbefalform.comment,
          UF_ENTERPRISE_SUM: 0,
          UF_CUSTOMER_ID: this.anbefalform.customerId,
          UF_RATING_COMMUNICATION: this.anbefalform.Kommunikation,
          UF_RATING_TIME: this.anbefalform.Overholdte,
          UF_RATING_ACCESS: this.anbefalform.Adgang,
          UF_RATING_REALISTIC_EXPECTATIONS: this.anbefalform.Realistike,
          UF_RATING_FINANCIAL_SECURITY: this.anbefalform.sikkerhed,
          UF_RATING_COLLABORATION: this.anbefalform.Samarbejdsvillighed
        }
        this.$http.post(this.$bitrixapi + 'partner/UpdateSavePartnerReviewonHomeowner', data, { headers }, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              this.closeformreditreview()
              let obj = {
                title: 'Gennemført!',
                message: 'Success',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
      }).catch(() => {
        console.log('ok')
      })
    },
    closeformreditreview () {
      this.$refs['editReviewForm'].hide()
    },
    deleteanbefal (item) {
      this.$confirm('Bekræft sletning', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        var data = {
          ID: item.ID
        }
        this.$http.post(this.$bitrixapi + 'partner/deleteReviewById', data, { headers }, { emulateJSON: true }).then(
          response => {
            let obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
            this.Reload()
          },
          err => {
            var error = err.body
            console.log(error)
          }
        )
      }).catch(() => {
      })
    }
  }
}
</script>
<style>
#editReviewForm .close {
      color: #003645!important;
      background-color: #fff!important;
}
#editReviewForm button.close  {
      padding: 0px!important;
}
#replyanswer .close {
      color: #003645!important;
      background-color: #fff!important;
}
#replyanswer button.close  {
      padding: 0px!important;
}
#imagedivreviewanbefaling {
  width: 240px;
  height: 90px;
}
#replyanswer .font12 {
  font-size: 12px;
}
#replyanswer .font14 {
  font-size: 14px;
}
#replyanswer .vue-rate-it-rating {
  align-items: start;
}
</style>


// WEBPACK FOOTER //
// Anbefaling.vue?63c76ce4